import './nando/style';
import FormStructure from './nando/form_structure';

export default FormStructure;